import AutomationToolBenefitsDesktop from "@components/AutomationToolBenefitsDesktop";
import AutomationToolBenefitsMobile, { AutomationToolBenefitsProps } from "@components/AutomationToolBenefitsMobile";
import PaymentProcessCard, { PaymentSectionDataProps } from "@components/integration/PaymentProcessCard";
import PaymentStepsAccordion, { PaymentProcess } from "@components/integration/PaymentStepsAccordion";
import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FAQSection, { FAQSectionProps } from "@components/new-ui/FAQSection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProblemSectionCard, { ProblemSection } from "@components/solution/problemSectionCard";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "",
    title: "WhatsApp Drip Marketing Software | Guide your leads through the sales funnel",
    description: "Deliver timely, personalized WhatsApp messages that give users the right nudge at the right time to convert them into a customer. ",
    primaryButtonText: "Start Free Trial",
    imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/drip-marketing-hero-image.png",
};

const featureInfo1: FeatureInfo = {
    mainTitle: "Customizable delivery preferences",
    imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/customizable-delivery.png",
    featureInfoList: ["Message-scheduling at regular intervals", "Personalization based on the user journey", "Different formats [image, video, links] for better engagement"],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Precise segmentation and targeting",
    imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/segmentation.png",
    featureInfoList: [
        "User segmentation by behavior, demographics, or past actions",
        "Message delivery to the right person at the right time",
        "Smarter campaigns that feel personal and timely",
    ],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Ready-to-use templates",
    imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/ready-to-use-templates.png",
    featureInfoList: ["Wide range of ready-to-use templates", "Scenario-based customization of templates", "Easy to launch campaigns without starting from scratch"],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Tech stack integration",
    imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/integration.png",
    featureInfoList: [
        "Seamless integrations with multiple platforms",
        "Data sync across platforms for a unified marketing flow",
        "Automation of drip campaigns without switching between systems",
    ],
};

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/case-study/alrannan-admin-service.png",
        chiptitle: "SERVICE",
        title: "How Alrannan Administrative Services automated sales with Gallabox",
        statsInfoData: [
            { percentage: "150%", label: "Projected quarterly business growth" },
            { percentage: "100%", label: "Increase in team productivity" },
        ],
        url: "/case-study/alrannan-administrative-services",
    },
];

const faqData: FAQSectionProps = {
    title: "FAQs about WhatsApp Drip Marketing Software",
    faqItems: [
        {
            question: "Can I automate personalized messages through WhatsApp Drip Marketing Software?",
            answer: "Yes, you can. Gallabox’s WhatsApp Drip Marketing tool lets you add that personal touch at scale. You can customize messages with placeholder tags for customer names, purchase history, or other data points in your CRM.",
        },
        {
            question: "Does WhatsApp Drip Marketing Software support multimedia content (images, videos, voice messages)?",
            answer: "Yes. You get the entire experience of your personal WhatsApp application. Our WhatsApp Drip Marketing software supports rich media like images, videos, PDFs, voice messages, and also interactive buttons. Text messages that contain multimedia get significantly higher engagement rates over plain text messages.",
        },
        {
            question: "How does WhatsApp Drip Marketing Software segment contacts for targeted messaging?",
            answer: "Our WhatsApp Drip campaign software gives you the flexibility to segment your audience based on parameters such as engagement history, custom tags, and CRM fields. You can even create dynamic segments that auto-update as customer behaviors change.",
        },
        {
            question: "Can I schedule WhatsApp drip campaigns to be sent at specific times?",
            answer: "With Gallabox’s WhatsApp drip campaigns solution, you can schedule messages down to the minute, ensuring they reach customers when they're most receptive. You can also set messages to reach different time zones, trigger on CRM actions, or schedule based on other custom rules automatically.",
        },
        {
            question: "How can I track the performance and success of my WhatsApp drip campaigns?",
            answer: "You can track every WhatsApp drip campaign on Gallabox by open rates, click-throughs, conversions, and more in real-time. This allows you to quickly spot what's working and make tweaks to campaigns on the go.",
        },
        {
            question: "Can WhatsApp Drip Marketing Software be integrated with my CRM or other marketing tools?",
            answer: "Yes. Gallabox’s WhatsApp Drip Marketing software connects seamlessly with popular CRMs like HubSpot, Zoho, Odoo, and LeadSquared. Some of the marketing tools we integrate with include MoEngage and WebEngage.",
        },
        {
            question: "Is WhatsApp Drip Marketing Software suitable for small businesses and large enterprises?",
            answer: "Gallabox’s WhatsApp Drip campaigns builder is tailor-made for businesses of all shapes and sizes. Whether you're sending 100 messages or 10,000 – our platform maintains the same level of performance, personalization, and scalability.",
        },

        {
            question: "How secure is the data collected through WhatsApp Drip Marketing Software?",
            answer: "All data is encrypted end-to-end, as mandated by WhatsApp Business API. As Gallabox’s WhatsApp Drip marketing solution is an official Meta partner, you don’t have to worry about data privacy and security. Gallabox never shares your customer data with third parties, and we implement regular security audits.",
        },
        {
            question: "Is WhatsApp Drip Marketing Software suitable for small businesses and large enterprises?",
            answer: "Gallabox’s WhatsApp Drip campaigns builder is tailor-made for businesses of all shapes and sizes. Whether you're sending 100 messages or 10,000 – our platform maintains the same level of performance, personalization, and scalability.",
        },
        {
            question: "How do I manage contact lists and automate follow-up messages in WhatsApp Drip Marketing Software?",
            answer: "Managing contacts is super straightforward in Gallabox’s WhatsApp Drip campaigns tool. You can import from a CSV file, sync from your CRM, or just add them one by one. You can choose their opt-in info as well to ensure compliance.",
        },
        {
            question: "Can I use WhatsApp Drip Marketing Software for both B2B and B2C marketing?",
            answer: "Yes, Gallabox’s WhatsApp Drip Marketing software has seenn amazing results in both spaces. Our B2C customers use us for product recommendations and flash sales, while B2B clients leverage our platform for qualifying and nurturing leads, and providing value-added content.",
        },
        {
            question: "Does WhatsApp Drip Marketing Software support A/B testing to optimize campaigns?",
            answer: "Yes, you can test different message variations, send times, or media types to see what resonates. With the software’s analytics, you can identify the winning strategies and adjust your campaigns accordingly.",
        },
        {
            question: "Can I send abandoned cart reminders or promotional offers via WhatsApp Drip Marketing Software?",
            answer: "Yes, abandoned cart reminders and promotional offers are great use cases for our WhatsApp drip marketing software. You can also add checkout URLs with offers from platforms like Shopify and Woocommerce to enable conversion-driven WhatsApp Drip marketing campaigns.",
        },
        {
            question: "How does WhatsApp Drip Marketing Software ensure compliance with WhatsApp's policies?",
            answer: "We've built compliance right into the core of our platform. Our system automatically enforces opt-in requirements, respects messaging windows, and maintains proper formatting. We also stay on top of WhatsApp's evolving policies and update our platform accordingly, so you can focus on marketing without worrying about technical violations.",
        },
    ],
};

const paymentSectionData: PaymentSectionDataProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/gallabox-home-page.png",
        title: "Create a new sequence",
        description: "Go to Sequences in the Gallabox dashboard and create a new sequence.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/set-trigger.png",
        title: "Set triggers",
        description: "Set the type of trigger to define when you want the sequence to start.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/set-conditions.png",
        title: "Set conditions",
        description: "Set the condition type to define the criteria a contact must meet to start the sequence.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/set-delivery.png",
        title: "Set delivery preferences",
        description: "Set the days and time range for the sequence’s messages to be delivered.",
    },
];

const defaultFAQData: PaymentProcess = {
    title: "How to get started with WhatsApp Drip Marketing Software",
    ProcessSteps: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/gallabox-home-page.png",
            title: "Create a new sequence",
            description: "Go to Sequences in the Gallabox dashboard and create a new sequence.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/set-trigger.png",
            title: "Set triggers",
            description: "Set the type of trigger to define when you want the sequence to start.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/set-conditions.png",
            title: "Set conditions",
            description: "Set the condition type to define the criteria a contact must meet to start the sequence.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/set-delivery.png",
            title: "Set delivery preferences",
            description: "Set the days and time range for the sequence’s messages to be delivered.",
        },
    ],
};

const automationToolBenefitsData: AutomationToolBenefitsProps = {
    title: "Smart drips that work across the customer journey",
    ProcessSteps: [
        {
            title: "Onboarding",
            description:
                "Sending a personalized welcome message can leave a lasting impression on a user’s mind. Set up fun messages with images or videos whenever a customer joins",
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/onboarding.png",
        },
        {
            title: "Customer support",
            description:
                "Identify and set up message sequences for repetitive scenarios. Common problems can be added to the sequence with relevant questions and answers for a better experience.",
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/cumstomer-support.png",
        },
        {
            title: "Sales",
            description:
                "Set up limited-time offers for previously browsed products and abandoned cart reminders. A simple message can convert a ready-to-buy customer into a buyer!",
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/sales.png",
        },
        {
            title: "Promotions",
            description: "From exclusive deals to seasonal offers, promote your product uniquely and keep reminding the customer of how awesome your brand is!",
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/promotions.png",
        },
        {
            title: "Payment follow-up",
            description: "Be it failed payments or subscription reminders, schedule messages based on the user scenario and ensure successful payments.",
            imageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/payment-follow-up.png",
        },
    ],
};

const productCardData: ProblemSection = {
    maintitle: "Benefits of using WhatsApp Drip Marketing Software",
    problemSectionCard: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/message-time.svg",
            title: "Enhanced Engagement Rates",
            description: "With WhatsApp having a higher open rate than any other platform, your messages are more likely to be seen and acted upon.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/time-hourglass.png",
            title: "Time and Resource Efficiency",
            description: "With ready-to-use templates and easy-to-set-up campaign builders, Gallabox’s WhatsApp drip marketing software makes marketing a breeze.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/customer-journey.png",
            title: "Improved Customer Journey",
            description: "With timely messages structured carefully to meet the customers’ needs at different stages in their user journey, conversions will be easy!",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/data-analysis.svg",
            title: "Data-Driven Decision Making",
            description: "Carefully analyse how each campaign is performing and make informed decisions to ensure that your marketing campaign is a success!",
        },
    ],
};

const WhatsappDripMarketing: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp Drip Marketing Software to convert more leads"
            description="Create tailor-made messages to engage customers at different levels of their buyer journey. Nurture leads and increase sales with Gallabox’s WhatsApp Drip Marketing Software!"
            canonical="https://gallabox.com/whatsapp-drip-marketing"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/drip-marketing/wa-drip-marketing-og.png" }}
            schema={{
                heroOrOgImageAlt: "whatsapp-drip-marketing-image",
                heroOrOgImageDescription: "Deliver timely, personalized WhatsApp messages that give users the right nudge at the right time to convert them into a customer.",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/drip-marketing/drip-marketing-hero-image.png",
                softwareFeatureName: "whatsapp-drip-marketing",
                howTo: { howtoSteps: defaultFAQData.ProcessSteps },
            }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} mt-10 mb-20`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos />
            </section>

            <h2 className="md:text-6xl text-4xl font-semibold pb-10 max-w-7xl mx-auto" style={{ fontFamily: "Degular Display" }}>
                Nurture and retain customers with Gallabox’s WhatsApp Drip Marketing Software
            </h2>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} removeDivider />

            <ProblemSectionCard problemSection={productCardData} bgColor="var(--Grad-7, linear-gradient(265deg, #396AFF -7.73%, #00238D 61.31%, #000 102.16%))" customStyle />

            <AutomationToolBenefitsDesktop automationToolBenefits={automationToolBenefitsData} />

            <AutomationToolBenefitsMobile automationToolBenefits={automationToolBenefitsData} />

            <PaymentProcessCard title="How to get started with WhatsApp Drip Marketing Software" paymentSectionData={paymentSectionData} backgroundColor="white" />

            <PaymentStepsAccordion paymentStepsData={defaultFAQData} />

            <CaseStudyFeatureSection features={caseStudyFeatureCardData} />
            <FAQSection faqData={faqData} />
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection
                title="Ready to Elevate Your Marketing Strategy?"
                description="Experience the power of Gallabox's WhatsApp drip marketing provider firsthand"
                primaryButtonText="Start Your 7-Day Free Trial"
            />
        </NewLayout>
    );
};

export default WhatsappDripMarketing;
